import React from 'react';
import { motion } from 'framer-motion';

const certifications = [
  'AWS Certified Solutions Architect – Associate',
  'Linux Foundation Kubernetes Fundamentals (in progress)'
];

const Certifications = () => {
  return (
    <section id="certifications" className="my-20 max-w-3xl mx-auto px-4">
      <motion.h2
        className="text-3xl font-bold mb-6 text-softPurple"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        Certifications
      </motion.h2>
      <ul className="space-y-6 text-gray-300">
        {/* AWS Certification */}
        <li className="flex items-center gap-4">
          <img
            src="/certification/aws_sa_badge.png"
            alt="AWS Badge"
            className="w-12 h-12"
          />
          <span>AWS Certified Solutions Architect – Associate</span>
        </li>

        <li className="flex items-center gap-4">
          <img
            src="/certification/aws_cp_badge.png"
            alt="AWS Badge"
            className="w-12 h-12"
          />
          <span>AWS Cloud practitioner</span>
        </li>

      {/* RedHat Certification */}
        <li className="flex items-center gap-4">
          <img
            src="/certification/redhat-ansibleautomation.png"
            alt="redhat ansible automation"
            className="w-12 h-12"
          />
          <span>Red Hat Ansible Automation Platform: Technical Seller </span>
        </li>

      <li className="flex items-center gap-4">
          <img
            src="/certification/redhat-openshift.png"
            alt="redhat OpenShift"
            className="w-12 h-12"
          />
          <span>Red Hat OpenShift: Technical Seller</span>
        </li>

        <li className="flex items-center gap-4">
          <img
            src="/certification/redhat-Foundation.png"
            alt="redhat Foundation"
            className="w-12 h-12"
          />
          <span>Red Hat Foundation</span>
        </li>

        <li className="flex items-center gap-4">
          <img
            src="/certification/GPS_tracker.jpg"
            alt="GPS Tracker Server Certification"
            className="w-12 h-12"
          />
          <span>GPS-Server Creation [Udemy] </span>
        </li>

        <li className="flex items-center gap-4">
          <img
            src="/certification/webdevelopment-ibm.png"
            alt="Web Development Certification"
            className="w-12 h-12"
          />
          <span>Web Development, JS, CSS and HTMl essential [IBM] </span>
        </li>

        <li className="flex items-center gap-4">
          <img
            src="/certification/intro_to_cloud_ibm.png"
            alt="Web Development Certification"
            className="w-12 h-12"
          />
          <span>Introduction to Cloud Computing [IBM] </span>
        </li>


        <li className="flex items-center gap-4">
          <img
            src="/certification/Loading_icon.gif"
            alt="Kubernetes"
            className="w-12 h-12"
          />
          <span>Linux Foundation Kubernetes Fundamentals (in progress)</span>
        </li>
      </ul>

    </section>
  );
};

export default Certifications;
